import { Box, Divider, Typography } from "@mui/material";
import React from "react";
import { useTheme } from "@mui/material/styles";
import Grid from "@mui/material/Grid2";
import { useStyles } from "../../assets/styles/Theme";
import { FormatDate } from "../../utils/common/DateUtils";

function GrnPdfInfo({ grnHeader }) {
  const theme = useTheme();
  const styles = useStyles(theme);

  const poData = grnHeader || {};
  const invoiceDate = poData.invoicedate || poData.invoiceDate || null;

  return (
    <Box
      sx={{
        color: "#000",
        "& *": {
          color: "#000 !important",
        },
      }}
    >
      <Divider sx={{ borderColor: "#000" }} />

      <Grid container py={1} spacing={8}>
        <Grid item size={{ xs: 12, sm: 4, md: 4, lg: 4, xl: 4 }}>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography variant="body_xs">
              <strong>Prepared by:</strong>{" "}
              {grnHeader?.grnenuser || "N/A"}
            </Typography>

            <Typography variant="body_xs">
              <strong>User ID:</strong>{" "}
              {grnHeader?.identitycode || "N/A"}
            </Typography>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Typography variant="body_xs">
                <strong>Date:</strong>{" "}
                {FormatDate(invoiceDate) || "-"}
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Divider sx={{ borderColor: "#000" }} />
    </Box>
  );
}

export default GrnPdfInfo;